import { useState } from "react";

interface PillInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string;
  onClearError?: () => void;
  type?: string;
  maxLength?: number;
  suffix?: string;
}

export default function PillInput({
  label,
  value,
  onChange,
  error,
  errorMessage,
  onClearError,
  type = "text",
  maxLength,
  suffix,
}: PillInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = value.length > 0;
  const isFloating = isFocused || hasValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (error && onClearError) {
      onClearError();
    }
    onChange(e);
  };

  return (
    <div
      className={`relative rounded-[56px] border border-solid bg-white ${error ? "border-red-500" : "border-[#d3d8db]"} flex h-[56px] items-center`}
    >
      <div className="relative h-full flex-1">
        <input
          type={type}
          value={value}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          maxLength={maxLength}
          className={`size-full flex-1 border-0 bg-transparent px-[24px] font-['Inter'] text-[16px] font-normal leading-[1.2] text-[#1d2124] outline-none ${isFloating ? "pb-[8px] pt-[20px]" : "py-[16px]"}`}
        />
        <label
          className={`pointer-events-none absolute left-[24px] font-['Inter'] transition-all duration-200 ease-out ${
            isFloating
              ? "top-[7px] text-[12px] text-[#1d2124]"
              : "top-[16px] text-[16px] text-[#1d2124]"
          }`}
        >
          {label}
        </label>
      </div>
      {suffix && (
        <div className="flex h-full items-center border-l border-solid border-[#d3d8db] px-[20px]">
          <span className="whitespace-nowrap font-['Inter'] text-[16px] font-medium leading-[1.2] text-grey600">
            {suffix}
          </span>
        </div>
      )}
      {error && errorMessage && (
        <p className="my-auto pr-4 text-[14px] font-normal leading-[1.4] text-[#dc2626]">
          {errorMessage}
        </p>
      )}
    </div>
  );
}
